export const COOKIE_API_TOKEN = 'bonkers-ie-api-token';
export const COOKIE_BROADBAND_ORDER = 'bonkers-ie-broadband-order';
export const COOKIE_BROADBAND_SEARCH = 'bonkers-ie-broadband-search';
export const COOKIE_CAR_INSURANCE_SEARCH = 'bonkers-ie-car-insurance-search';
export const COOKIE_CAR_INSURANCE_VEHICLE = 'bonkers-ie-car-registration';
export const COOKIE_CURRENT_ACCOUNT_SEARCH = 'bonkers-ie-current-account-search';
export const COOKIE_CURRENT_ACCOUNT_TYPE = 'bonkers-ie-current-account-type';
export const COOKIE_LOAN_SEARCH = 'bonkers-ie-loan-search';
export const COOKIE_MORTGAGE_CAPTURE_POINT = 'bonkers-ie-mortgage-capture-point';
export const COOKIE_MORTGAGE_JOURNEY = 'bonkers-ie-mortgage-journey';
export const COOKIE_MORTGAGE_LEAD = 'bonkers-ie-mortgage-lead';
export const COOKIE_MORTGAGE_SEARCH = 'bonkers-ie-mortgage-search';
export const COOKIE_SAVINGS_ACCOUNT_SEARCH = 'bonkers-ie-savings-account-search';
export const COOKIE_SAVINGS_ACCOUNT_TYPE = 'bonkers-ie-savings-account-type';
export const COOKIE_SELECTED_PRODUCT = 'bonkers-ie-selected-product';
export const COOKIE_SESSION = '_bonkers_session';
